import { clsx, type ClassValue } from 'clsx';
import { formatDistanceToNowStrict, format, parseISO } from 'date-fns';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const ago = (d: string | Date | null | undefined) => (d ? formatDistanceToNowStrict(typeof d === 'string' ? new Date(d) : d, { addSuffix: true }) : '');
export const fmtDate = (d: string | null | undefined, f = 'd MMM yyyy') => (d ? format(d.length === 10 ? parseISO(d) : new Date(d), f) : '—');
export const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const addDaysIso = (iso: string, n: number) => {
  const d = parseISO(iso);
  d.setDate(d.getDate() + n);
  return format(d, 'yyyy-MM-dd');
};
export const startOfWeekIso = (iso = today()) => {
  const d = parseISO(iso);
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  return format(d, 'yyyy-MM-dd');
};
export const bytes = (n: number) => (n < 1024 ? `${n} B` : n < 1024 ** 2 ? `${(n / 1024).toFixed(1)} KB` : n < 1024 ** 3 ? `${(n / 1024 ** 2).toFixed(1)} MB` : `${(n / 1024 ** 3).toFixed(2)} GB`);
export const initials = (name?: string | null) =>
  (name ?? '?')
    .split(/\s+/)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

export const doc = (text: string) => ({ type: 'doc', content: text.split('\n').map((l) => ({ type: 'paragraph', content: l ? [{ type: 'text', text: l }] : [] })) });
